import React, { useEffect, useState } from "react";
import { FiX, FiTrash2, FiKey } from "react-icons/fi";
import axios from "axios";
import { API_BASE_URL } from "../utils/crudFunctions";
import { getToken } from "../utils/auth";

const UserSidebar = ({ onClose, users }) => {


  return (
    <div className="fixed right-0 top-0 w-80 h-full bg-white shadow-lg z-50 border-l border-gray-200 px-4 py-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">User Management</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-red-500">
          <FiX size={20} />
        </button>
      </div>

      <div className="space-y-4 overflow-y-auto max-h-[calc(100%-60px)]">
        {users.map((user, index) => (
          <div
            key={index}
            className="bg-gray-100 p-3 rounded-lg flex items-center justify-between"
          >
            <span className="text-sm font-medium text-gray-800">{user.username}</span>
            <div className="flex gap-2">
              <button className="text-blue-600 hover:text-blue-800">
                <FiKey />
              </button>
              <button className="text-red-500 hover:text-red-700">
                <FiTrash2 />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserSidebar;
